module.exports = __webpack_public_path__ + "static/img/3_1_2_2.354a769d.jpg";